import * as types from '../../../constants/ActionTypes';

export const setBoolEditData = editData => ({
    type: types.SET_BOOL_EDIT_DATA,
    editData,
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetailsSummary/applicantDetailsSummaryActions.js